import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { Campaign } from '../../../model/campaign/Campaign';
import TableSkeleton, { ITableColumn } from '../../../shared/components/TableSkeleton';
import { formatDate } from '../../../utils/Functions';

const CAMPAIGN_COLUMNS: ITableColumn[] = [
    { label: 'ID' },
    { label: 'Name' },
    { label: 'Created', className: 'text-right' },
];

const SKELETON_ROWS = 10;

export function LatestCampaignsList({ campaigns, isLoading = false }: { campaigns: Campaign[]; isLoading?: boolean }) {
    return (
        <Card className="p-4 mt-3 col-md-5-5 col-sm-12">
            <h5 className="p-3">Latest Campaigns</h5>
            {isLoading ? (
                <TableSkeleton columns={CAMPAIGN_COLUMNS} rows={SKELETON_ROWS} />
            ) : (
                <Table hover responsive>
                    <thead>
                        <tr>
                            {CAMPAIGN_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {campaigns?.map(e => (
                            <tr key={e.id}>
                                <td>{e.id}</td>
                                <td>{e.title}</td>
                                <td className="text-right">{formatDate(e.createdAt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Card>
    );
}
